import { Component, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

export interface ExpertFilters {
  searchQuery: string;
  expertType: string;
  minRating: number;
  sortBy: string;
}

@Component({
  selector: 'app-experts-filters',
  imports: [FormsModule, TranslatePipe],
  templateUrl: './experts-filters.html',
  styleUrl: './experts-filters.scss',
})
export class ExpertsFiltersComponent implements OnInit, OnDestroy {
  searchQuery: string = '';
  expertType: string = 'all';
  minRating: number = 0;
  sortBy: string = 'rating';

  @Output() filtersChange = new EventEmitter<ExpertFilters>();

  private searchSubject = new Subject<string>();
  private subscription?: Subscription;

  ngOnInit() {
    this.subscription = this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe((query) => {
      this.searchQuery = query;
      this.emitFilters();
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  onSearchChange(query: string): void {
    this.searchSubject.next(query);
  }

  onFilterChange(): void {
    this.emitFilters();
  }

  private emitFilters(): void {
    this.filtersChange.emit({
      searchQuery: this.searchQuery,
      expertType: this.expertType,
      minRating: Number(this.minRating),
      sortBy: this.sortBy,
    });
  }
}
